import { deleteField } from 'firebase/firestore';

export const removeUndefinedFields = (
  obj: { [k: string]: any },
  options?: { undefinedTo?: 'null' | 'deleteField' },
) => {
  const { undefinedTo } = options || {};

  const newObj = { ...obj };

  for (const key in newObj) {
    if (newObj[key] === undefined) {
      if (undefinedTo === 'null') {
        newObj[key] = null;
      } else if (undefinedTo === 'deleteField') {
        newObj[key] = deleteField();
      } else {
        delete newObj[key];
      }
    }
  }

  return newObj;
};
